import dayjs from '../libs/dayjs'

export function calcDiffDays(dataFim: string) {
    // const dataAgoraMilli: any = new Date()
    // const dataLiquidacaoMilli: any = new Date(dataFim)
    //
    const dataLiquidacao = dayjs(dataFim)
    const dataAgora = dayjs()
    const diffMil = dataLiquidacao.diff(dataAgora)
    // const diffMil = (dataLiquidacaoMilli - dataAgoraMilli)
    const diffDays = Math.ceil(diffMil / (1000 * 60 * 60 * 24))
    return diffDays
}

export function validateData(value: string) {
    const dataHoje = dayjs()
    const dataPrimeiraCobranca = dayjs(value)
    const diff = dataPrimeiraCobranca.diff(dataHoje)
    const diffDays = diff / 86400000
    if (diffDays < 4) {
        return false
    }
    if (dayjs(value).day() === 0 || dayjs(value).day() === 6) {
        return false
    }
    return true
}
